'use client'

import React, { useState } from 'react'

import { useQuery } from '@apollo/client'

import { BookMeetingModal } from 'Components/Blocks/Modals'
import {
  AccessTopCoursesSection,
  BookMeetingSection,
  ExecutiveInviteHeroSection,
  ExecutiveInviteHowItWorksSection,
  ExecutiveInviteQuestionSection,
  ExecutiveInviteWelcomeSection,
  GrowYourNetworkSection,
  LatestEventsSection,
  LearnFromTopVoicesSection,
  MeetOutMembersSection,
  MoreThanJustGolfSection,
  OurPlatinumMembersSection,
  WhoIsEmajinForSection,
} from 'Components/Sections'
import { Column, Loader } from 'Components/UI'
import { APOLLO_CLIENT_CONTEXT_ID } from 'Config/apolloClient'

import { HomePageDocument } from 'GraphQL/DatoCMS/TypedDocuments'

function ExecutiveInvitePage() {
  const [bookMeetingModalOpened, setBookMeetingModalOpened] = useState(false)

  const { data, loading } = useQuery(HomePageDocument, {
    context: { [APOLLO_CLIENT_CONTEXT_ID.Dato]: true },
  })

  if (loading) return <Loader fullScreen size={32} />

  return (
    <Column alignCenter fullWidth>
      <ExecutiveInviteHeroSection />

      <MoreThanJustGolfSection
        onAction={() => setBookMeetingModalOpened(true)}
      />

      <ExecutiveInviteQuestionSection />

      <ExecutiveInviteWelcomeSection
        onAction={() => setBookMeetingModalOpened(true)}
      />

      <AccessTopCoursesSection />

      <WhoIsEmajinForSection />

      <GrowYourNetworkSection
        onAction={() => setBookMeetingModalOpened(true)}
      />

      <BookMeetingSection />

      <LearnFromTopVoicesSection
        onAction={() => setBookMeetingModalOpened(true)}
      />

      <LatestEventsSection />

      <MeetOutMembersSection data={data?.homePage?.testimonial} />

      <ExecutiveInviteHowItWorksSection />

      <BookMeetingSection />

      <OurPlatinumMembersSection data={data} />

      <BookMeetingModal
        isOpened={bookMeetingModalOpened}
        onClose={() => setBookMeetingModalOpened(false)}
      />
    </Column>
  )
}

export default ExecutiveInvitePage
